import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientVMSSubInfo, TalentVMSSubInfo } from "../../../../typings";
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { PageService } from "../shared/page-service";
import { Router } from "@angular/router";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { VmsSubmittalApiService } from "../vms-submittal-api.service";
import { DobOptions, TalentProfileStartAvailability, VmsSubmittalPage } from '../../../enums';
import { UtilService } from '../../talent-profile/shared/util.service';

@Component({
  selector: 'app-vms-submittal-candidate-validation',
  templateUrl: './vms-submittal-candidate-validation.component.html',
  styleUrl: './vms-submittal-candidate-validation.component.scss',
  standalone: false
})
export class VmsSubmittalCandidateValidationComponent {

  @Input() clientVMSSubInfo: ClientVMSSubInfo;
  showBackButton: boolean = false;
  talentVMSSubInfo: TalentVMSSubInfo;
  showAgreement: boolean = false;
  saving: boolean = false;
  showTaxId: boolean = false;
  @Output() pageLoading = new EventEmitter<boolean>();
  birthDate: Date;
  r2rForm: FormGroup;
  personId: number;

  constructor(private pageService: PageService,
              private router: Router,
              private talentHappyPathDataService: TalentHappyPathDataService,
              private vmsSubApiService: VmsSubmittalApiService,
              private fb: FormBuilder,
              private utils: UtilService

  ) {}

  ngOnInit() {
    // We may have dropped into the app from a Gather link
    if(this.isFromGather()) {
      if(!this.clientVMSSubInfo.vmsSubGatherInfo.candidateValidationRequired) {
        this.nextPage();
      }
    }
    this.personId = this.talentHappyPathDataService.talent.personId;
    this.initForm();

    this.vmsSubApiService.getTalentVMSSubInfo(this.talentHappyPathDataService.orderId, this.talentHappyPathDataService.talent.personId).subscribe(vmsSubInfo => {
      this.talentVMSSubInfo = vmsSubInfo;
      if((vmsSubInfo.birthDate != null && vmsSubInfo.birthDate != "") || (vmsSubInfo.taxId != '' && vmsSubInfo.taxId != null)) {
        this.nextPage();
      }
      this.pageLoading.emit(false);
    }, error => {
      this.pageLoading.emit(true);
    });
  }

  initForm() {
    this.r2rForm = this.fb.group({
      birthDate: ['', this.clientVMSSubInfo?.dobRequired ?
        [Validators.required, this.validBirthDateValidator(this.clientVMSSubInfo?.dobOptionId)] : null],
      taxIdDigits: ['', this.clientVMSSubInfo?.taxIdRequired ?
        [Validators.required, this.exactLengthValidator(this.clientVMSSubInfo?.taxIdLength)] : null]
    });
  }

  validBirthDateValidator(dobOption: DobOptions): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value;


      if (!value) {
        return { invalidFormat: true };
      }

      if (dobOption === DobOptions.PARTIAL_DOB) {
        const [month, day] = value.split('/').map(Number);

        // Check month range (01-12)
        const validMonth = month >= 1 && month <= 12;
        // Check day range (01-31)
        const validDay = day >= 1 && day <= 31;

        if (!validDay || !validMonth) {
          return {
            invalidDateRange: {
              validMonth,
              validDay
            }
          };
        }
      }

      return null;
    };
  }

  onBirthDateChange(newDate: Date) {
    this.birthDate = newDate;
    this.r2rForm.patchValue({
      birthDate: this.utils.dateToString(newDate)
    });
  }

  exactLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const valid = control.value && control.value.length === length;
      return valid ? null : {'exactLength': {required: length, actual: control.value?.length}};
    };
  }

  goToNextPage() {
    this.saving = true;
    this.talentVMSSubInfo.birthDate = this.r2rForm.controls['birthDate'].value;
    this.talentVMSSubInfo.taxId = this.r2rForm.controls['taxIdDigits'].value;

    this.vmsSubApiService.saveTalentValidationInfo(this.talentVMSSubInfo)
      .subscribe(() => {
        this.saving = false;
        this.nextPage();
      }, () => {
        console.error("Error saving VMS");
        this.saving = false;
      });
  }

  goToPreviousPage() {
  }

  disableSubmit() {
    return this.r2rForm.invalid || this.saving;
  }

  formatBirthDate(): void {
    const control = this.r2rForm.controls['birthDate'];
    if (!control) return;

    let value = control.value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    control.setValue(value, { emitEvent: false });
  }

  formatTaxId(): void {
    const control = this.r2rForm.controls['taxIdDigits'];
    if (!control) return;

    let value = control.value.replace(/\D/g, '');
    control.setValue(value, { emitEvent: false });
  }

  toggleTaxVisibility(): void {
    this.showTaxId = !this.showTaxId;
  }

  nextPage(): void {
    if(this.isFromGather()) {
      if((this.clientVMSSubInfo.vmsSubGatherInfo.employmentHistoryRequired
        && Object.values(this.clientVMSSubInfo.clientEmploymentHistory).some(value => value === true))
        || this.clientVMSSubInfo.vmsSubGatherInfo.relationshipDisclosureRequired
        || this.clientVMSSubInfo.ernstAndYoungEmploymentHistoryRequired)
      {
        this.pageService.setActivePage(VmsSubmittalPage.EMPLOYMENT_HISTORY_AND_RELATIONSHIP_DISCLOSURE);
      }
      else {
        // gatheruuid is the gather tracking token, not the numeric gather id: the IIQ pages hand it
        // straight to /api/gather/token/{token} and into the do-this-later email link.
void this.router.navigate(['/initial-interview'], { queryParams: { gatheruuid: this.talentHappyPathDataService.gatherToken }, skipLocationChange: true });
      }
    }
    else {
      if(Object.values(this.clientVMSSubInfo.clientEmploymentHistory).some(value => value === true)
      || this.clientVMSSubInfo.relationshipDisclosureRequired
      || this.clientVMSSubInfo.ernstAndYoungEmploymentHistoryRequired) {
        this.pageService.setActivePage(VmsSubmittalPage.EMPLOYMENT_HISTORY_AND_RELATIONSHIP_DISCLOSURE);
      }
      else {
        this.router.navigate(['thank-you'], {queryParams: { from: 'vms-submittal' }, skipLocationChange: true});
      }
    }
  }

  isFromGather(): boolean {
    return this.talentHappyPathDataService.gather != null && this.talentHappyPathDataService.gather.gatherId != null;
  }

  protected readonly DobOptions = DobOptions;

  get dobOptionId() {
    return this.clientVMSSubInfo.dobOptionId;
  }

  protected readonly talentProfileStartAvailability = TalentProfileStartAvailability;
}
